import React from 'react';

import { Button, Center, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { IconBolt } from '@tabler/icons-react';

/**
 * Shared empty state for the GLM flow tables (both directions) when no flows exist.
 */
const FlowsEmptyState = ({
  description,
  onCreate,
}: {
  description: string;
  onCreate: () => void;
}): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <Center h='60vh'>
      <Stack align='center' spacing='xs' maw={420}>
        <IconBolt size={40} color={theme.colors.kiloBlue[4]} />
        <Title order={4}>No automations yet</Title>
        <Text color='dimmed' align='center'>
          {description}
        </Text>
        <Button mt='xs' onClick={onCreate}>
          New automation
        </Button>
      </Stack>
    </Center>
  );
};

export default FlowsEmptyState;
